import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Описание кнопки модального окна. */
let DxModalButton = class DxModalButton {
    constructor(fields) {
        this._ord = 1;
        this._disabled = false;
        this.visible = true;
        if (fields)
            Object.assign(this, fields);
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get icon() {
        return this._icon;
    }
    set icon(value) {
        this._icon = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value;
    }
    get resultType() {
        return this._resultType;
    }
    set resultType(value) {
        this._resultType = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxModalButton.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "icon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxModalButton.prototype, "_icon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxModalButton.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "disabled", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxModalButton.prototype, "_disabled", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxModalButton.prototype, "visible", void 0);
tslib_1.__decorate([
    jsonMember({ name: "resultType", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxModalButton.prototype, "_resultType", void 0);
DxModalButton = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], DxModalButton);
export { DxModalButton };
